import moment from "moment";
import { getLocationName } from "./auth";

var reasons = [
  { value: "ADD", text: "Nhập kho", index: 0 },
  { value: "RETURN", text: "Hoàn trả", index: 1 },
  { value: "RECOUNT", text: "Đếm lại", index: 2 },
  { value: "BROKEN", text: "Hỏng hóc", index: 3 },
  { value: "LOST", text: "Bị trộm", index: 4 },
  { value: "NOTFOUND", text: "Thất lạc", index: 5 },
];
var sortTypes = [
  { id: "ALPHABETIC_ASC", text: "Sắp xếp theo A-Z" },
  { id: "ALPHABETIC_DESC", text: "Sắp xếp theo Z-A" },
  { id: "QUANTITY_ASC", text: "Số lượng nhỏ - lớn" },
  { id: "QUANTITY_DESC", text: "Số lượng lớn - nhỏ" },
];
function formatMoney(val) {
  val = val
    .toString()
    .split(".")
    .join("");
  let output = "";
  while (val.length >= 3) {
    const last3Digits = val.slice(val.length - 3, val.length);
    val = val.slice(0, val.length - 3);
    output = "." + last3Digits + output;
  }
  if (val.length === 0) {
    output = output.slice(1, output.length);
  } else {
    output = val + output;
  }
  return output;
}
function removeDot(val) {
  if (typeof val == "number") {
    return val;
  }else{
    if (val) {
      const checkType = val.includes(",");
      if (checkType) {
        return val
          .split(",")
          .filter((str) => str !== ",")
          .join("");
      } else {
        return val
          .split(".")
          .filter((str) => str !== ".")
          .join("");
      }
    }
  }
}
var statusPayment = [
  { value: 1, text: "Chờ thanh toán", color: "warning" },
  { value: 2, text: "Thanh toán một phần", color: "primary" },
  { value: 3, text: "Đã thanh toán", color: "success" },
  { value: 4, text: "Hoàn tiền một phần", color: "primary" },
  { value: 5, text: "Hoàn tiền toàn bộ", color: "danger" },
];
var statusSwitchStorage = [
  { value: 1, text: "Nháp", color: "warning" },
  { value: 2, text: "Đang tiến hành", color: "primary" },
  { value: 3, text: "Hoàn thành", color: "success" },
  { value: 4, text: "Đã hủy", color: "danger" },
  { value: 5, text: "Bị từ chối", color: "info" },
];

function statusCheckInStorage(val) {
  switch (val) {
    case "DRAFT":
      return {
        color: "warning",
        text: "Nháp",
        title: "Đơn nhập",
        label: "DRAFT",
        value: 0,
      };
    case "PROCESSING":
      return {
        color: "primary",
        text: "Đang tiến hành",
        title: "Đơn nhập",
        label: "PROCESSING",
        value: 1,
      };
    case "CREATE":
      return {
        text: "Mới tạo",
        title: "Đơn nhập",
        label: "CREATE",
        value: 2,
      };
    case "SUCCESS":
      return {
        color: "success",
        text: "Hoàn thành",
        title: "Đơn nhập",
        label: "SUCCESS",
        value: 3,
      };
    case "CANCELED":
      return {
        color: "danger",
        text: "Đã hủy",
        title: "Hủy đơn",
        label: "CANCELED",
        value: 4,
      };
    default:
      return {
        color: "info",
        text: "Không tồn tại",
        title: "Chỉnh sửa đơn",
        label: "Empty",
        value: -1,
      };
  }
}

function OrderReturnStatus(val) {
  switch (val) {
    case "PROCESSING":
      return {
        color: "primary",
        text: "Đang tiến hành",
        title: "Đang tiến hành",
        label: "PROCESSING",
        value: 1,
      };
    case "COMPLETE":
      return {
        color: "success",
        text: "Hoàn thành",
        title: "",
        label: "COMPLETE",
        value: 4
      }
    case "CANCEL":
      return {
        color: "danger",
        text: "Đã hủy",
        title: "",
        label: "CANCEL",
        value: 4
      }
    default:
      return {
        color: "info",
        text: "Không tồn tại",
        title: "Chỉnh sửa đơn",
        label: "Empty",
        value: -1,
      };
  }
}

function OrderDeliveryStatus(val) {
  switch (val) {
    case "NEW":
      return {
        color: "warning",
        text: "Chờ giao cho shipper",
        title: "",
        label: "PROCESSING",
        value: 1,
      };
    case "COMPLETE":
      return {
        color: "success",
        text: "Giao hàng thành công",
        title: "",
        label: "COMPLETE",
        value: 3
      }
    case "CANCEL":
      return {
        color: "danger",
        text: "Đã hủy",
        title: "",
        label: "CANCEL",
        value: 4
      }
    case "PROCESSING":
      return {
        color: "primary",
        text: "Đang giao hàng",
        title: "",
        label: "PROCESSING",
        value: 2
      }
      case "FAILED":
        return {
          color: "danger",
          text: "Đã hủy",
          title: "",
          label: "CANCEL",
          value: 5
        }
    default:
      return {
        color: "primary",
        text: "Lỗi rồi",
        title: "",
        label: "DRAFT",
        value: 0
      }
  }
}

function statusAction(val) {
  switch (val) {
    case "CREATE":
      return {
        text: "Mới tạo",
        value: "CREATE",
      };
    case "UPDATE":
      return {
        text: "Nhập kho",
        value: "UPDATE",
      };
    case "CONFIRM":
      return {
        text: "Đang nhập kho",
        value: "CONFIRM",
      };
    case "IMPORT":
      return {
        text: "Hoàn thành",
        value: "IMPORT",
      };
    case "CANCELED":
      return {
        text: "Thất bại",
        value: "CANCELED",
      };
    default:
      return {};
  }
}
var statusTrasfer = [
  {
    value: "DRAFT",
    label: "Đơn nháp",
  },
  {
    value: "SUCCESS",
    label: "Hoàn thành",
  },
  {
    value: "CANCELED",
    label: "Bị hủy",
  },
];
function statusCodeResponse(val) {
  switch (val) {
    case "QUANTITY_MISMATCH_SERIES":
      return "Số lượng sản phẩm khác số series";
    case "ORDER_IS_EXPIRED":
      return "Đơn nháp đã hết hạn";
    case "ORDER_NO_EXIST":
      return "Mã đơn đã tồn tại";
    case "ORDER_NO_INVALID":
      return "Mã đơn không hợp lệ";
    case "LOCK_SERIES_ERROR":
      return "Không khóa được series này khi cập nhật đơn chuyển thành công";
    default:
      break;
  }
}
var ranges = {
  "Hôm nay": [moment().startOf("day")._d, moment().endOf("day")._d],
  "Hôm qua": [
    moment()
      .subtract(1, "days")
      .startOf("day")._d,
    moment()
      .subtract(1, "days")
      .endOf("day")._d,
  ],
  "7 ngày trước": [
    moment()
      .subtract(7, "days")
      .startOf("day")._d,
    moment()
      .subtract(1, "days")
      .endOf("day")._d,
  ],
  "30 ngày trước": [
    moment()
      .subtract(30, "days")
      .startOf("day")._d,
    moment()
      .subtract(1, "days")
      .endOf("day")._d,
  ],
  "Tuần trước": [
    moment()
      .subtract(1, "week")
      .startOf("week")._d,
    moment()
      .subtract(1, "week")
      .endOf("week")._d,
  ],
  "Tháng trước": [
    moment()
      .subtract(1, "month")
      .startOf("month")._d,
    moment()
      .subtract(1, "month")
      .endOf("month")._d,
  ],
  "3 tháng trước": [
    moment()
      .startOf("month")
      .subtract(3, "month")._d,
    moment()
      .endOf("month")
      .subtract(1, "month")._d,
  ],
  "Đầu tuần đến nay": [moment().startOf("week")._d, moment()._d],
  "Đầu tháng đến nay": [moment().startOf("month")._d, moment()._d],
  "Đầu năm đến nay": [moment().startOf("year")._d, moment()._d],
};
var localeDateRange = {
  format: "dd/mm/yyyy",
  applyLabel: "Xác nhận",
  cancelLabel: "Hủy",
  daysOfWeek: ["CN", "T2", "T3", "T4", "T5", "T6", "T7"],
  monthNames: [
    "Tháng 1",
    "Tháng 2",
    "Tháng 3",
    "Tháng 4",
    "Tháng 5",
    "Tháng 6",
    "Tháng 7",
    "Tháng 8",
    "Tháng 9",
    "Tháng 10",
    "Tháng 11",
    "Tháng 12",
  ],
};
function transferLineItemBarCode(lineItem) {
  const items = lineItem.map(item => {
    const itemInstance = item.itemInstance

    let exportPrice = 0
    itemInstance.prices.map((vl,idx)=>{
      if(vl.priceTypeCode === 'PRICE_EXPORT'){
        exportPrice = itemInstance.prices[idx].amount/1000
      }
    }) 
    const inforMerchant = JSON.parse(localStorage.getItem("auth.currentMerchant"))
    return {
      amount: exportPrice,
      images: item.images,
      lineItemId: item.lineItemId,
      mcName: inforMerchant.name,
      name: itemInstance.name,
      quantity: item.quantity,
      sku: itemInstance?.moreInformation.sku,
      unitPrice: exportPrice,
      upc: itemInstance?.moreInformation.upc,
      itemVariationId: itemInstance.itemVariationId
    }
  })
  return items
}
function transferBatch(arrs) {
  const result = []
  arrs.forEach(arr => {
    const lineItemOtherInfo = {
      ...arr.lineItemOtherInfo,
      quantityChoose: arr.quantity,
      manufactureDate: arr.lineItemOtherInfo.MANUFACTURE_DATE,
      expirationDate: arr.lineItemOtherInfo.EXPIRATION_DATE,
      batchCode: arr.lineItemOtherInfo.BATCH_CODE,
      value: arr.lineItemOtherInfo.BATCH_CODE
    }
    let detail = false;
    if(arr.lineItemOtherInfo.BATCH_CODE) {
      detail = true
    } else if (arr.lineItemOtherInfo.seriesNo) {
      detail = true
    } else {
      detail = false
    }
    const batch = arr.lineItemOtherInfo.BATCH_CODE ? true : false
    result.push({
      ...arr,
      useProductBatch: batch,
      _showDetails: detail,
      batchSelect: batch ? [lineItemOtherInfo] : []
    })
  })
  return result
}

const allPayment = {
  CASH_NEXT_SHOP: {
    name: "Tiền mặt",
    paymentMethod: "CASH",
    paymentGateway: "NEXT_SHOP"
  },
  BANK_TRANSFER_NEXT_SHOP: {
    name: "Chuyển khoản",
    paymentMethod: "BANK_TRANSFER",
    paymentGateway: "NEXT_SHOP"
  },
  SWIPE_MPOS: {
    name: "Quẹt thẻ MPOS",
    paymentMethod: "SWIPE",
    paymentGateway: "MPOS"
  },
  SWIPE_OTHER: {
    name: "Quẹt thẻ ngoài MPOS",
    paymentMethod: "SWIPE",
    paymentGateway: "OTHER"
  },
  DEBT_NOTE_NEXT_SHOP: {
    name: "Ghi nợ",
    paymentMethod: "DEBT_NOTE",
    paymentGateway: "NEXT_SHOP"
  },
  REFUND_NEXT_SHOP: {
    name: "Hoàn tiền",
    paymentMethod: "REFUND",
    paymentGateway: "NEXT_SHOP"
  },
  COD_NEXT_SHOP: {
    name: "COD",
    paymentMethod: "COD",
    paymentGateway: "NEXT_SHOP"
  },
}

export function getDeliveryStatus(status, oder) {
  // console.log(status, oder);
  if(status == "NEW" && oder) {
    const result = checkIsPushedToPartner(oder)
    if(result != null && result == false) return {
      status: "INFO",
      text: "Chờ xác nhận",  
    }
  }

  switch (status) {
    case "NEW":
      return {
        status: "DRAFT",
        text: "Chờ giao hàng",  
      };
    case "PROCESSING":
      return {
        status: "PROCESSING",
        text: "Đang giao hàng",
      };
    case "COMPLETE":
      return {
        status: "COMPLETE",
        text: "Giao thành công",
      };
    case "FAILED":
      return {
        status: "FAILED",
        text: "Đã hủy",
      };

    default:
      return {
        status: status,
        text: "",
      };
  }
}

function checkIsPushedToPartner(oder) {
  const SO_ORDER_OPERATION = oder.furtherInstructions.find(e => e && e.key == "SO_ORDER_OPERATION")
  if(
    SO_ORDER_OPERATION 
    && SO_ORDER_OPERATION.params 
    && SO_ORDER_OPERATION.params.deliveryStatus == "NEW"
    && SO_ORDER_OPERATION.params.deliveryTargetService == "DELIVERY_PARTNER"
    )
    {
      if(SO_ORDER_OPERATION.params.isPushedDeliveryToPartner == "true")
      return true
      else return false
    }
    else return null
}

export {
  reasons,
  sortTypes,
  statusPayment,
  statusSwitchStorage,
  formatMoney,
  statusCheckInStorage,
  statusAction,
  statusTrasfer,
  statusCodeResponse,
  removeDot,
  ranges,
  localeDateRange,
  transferLineItemBarCode,
  transferBatch,
  OrderReturnStatus,
  OrderDeliveryStatus,
  allPayment,
};
